module.exports = __webpack_public_path__ + "img/right_hand.png";